import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const HireRequestBannerSection = () => {
  return (
    <section className="bg-primary text-white py-16 md:py-20 px-4">
      <div className="container mx-auto flex flex-wrap items-end justify-between gap-10">
        <div className="max-w-2xl">
          <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            One system. Every step.
          </p>
          <h2 className="text-white font-poppins font-bold tracking-[-0.03em] leading-tight text-3xl md:text-4xl lg:text-5xl mb-5">
            The Talent Is Ready.{" "}
            <span className="text-secondary">Build Your Global Team.</span>
          </h2>
          <span className="text-indigo-100 font-poppins text-base md:text-lg leading-relaxed block">
            Access work-ready professionals and the infrastructure to hire,
            manage and pay them anywhere.
          </span>
        </div>

        <div className="grid gap-3 w-full sm:w-auto min-w-[230px]">
          <a
            href="https://app.utiva.co/signup?goal=employer"
            target="_blank"
            rel="noreferrer noopener"
            className="bg-secondary text-primary font-poppins font-extrabold rounded-xl flex items-center justify-between gap-4 px-5 py-4 custom-btn"
          >
            Start Hiring <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
          <Link
            to="/pay"
            className="border border-white/30 text-white font-poppins font-extrabold rounded-xl flex items-center justify-between gap-4 px-5 py-4 custom-btn"
          >
            Explore Manage &amp; Pay <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HireRequestBannerSection;
